module.exports = __webpack_public_path__ + "img/7.5230cfd1.jpg";